document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-rh-menu-toggle]')
  const menu = document.getElementById('rh-mobile-menu')
  if (!toggle || !menu) return
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  let closeTimer

  const finishMenuClose = (restoreFocus) => {
    window.clearTimeout(closeTimer)
    closeTimer = undefined
    menu.classList.remove('is-closing')
    menu.toggleAttribute('hidden', true)
    document.body.classList.remove('rh-menu-open', 'rh-menu-closing')
    if (restoreFocus) toggle.focus()
  }

  const setMenuOpen = (open, restoreFocus = false) => {
    toggle.setAttribute('aria-expanded', String(open))
    menu.setAttribute('aria-hidden', String(!open))

    if (open) {
      window.clearTimeout(closeTimer)
      menu.classList.remove('is-closing')
      menu.toggleAttribute('hidden', false)
      document.body.classList.remove('rh-menu-closing')
      document.body.classList.add('rh-menu-open')
      return
    }

    if (menu.hasAttribute('hidden')) return
    if (menu.classList.contains('is-closing')) return
    if (reducedMotion.matches) {
      finishMenuClose(restoreFocus)
      return
    }

    menu.classList.add('is-closing')
    document.body.classList.add('rh-menu-closing')
    closeTimer = window.setTimeout(() => finishMenuClose(restoreFocus), 650)
  }

  toggle.addEventListener('click', () => {
    setMenuOpen(toggle.getAttribute('aria-expanded') !== 'true')
  })

  menu.querySelectorAll('[data-rh-menu-close]').forEach((closeButton) => {
    closeButton.addEventListener('click', () => setMenuOpen(false, true))
  })

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setMenuOpen(false))
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenuOpen(false, true)
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.rh-hero--motion')
  if (!hero) return

  const title = hero.querySelector('.rh-hero__title')
  const characters = hero.querySelectorAll('.rh-hero__title-char')
  const slides = Array.from(hero.querySelectorAll('.rh-hero__slide'))
  const desktopLayout = window.matchMedia('(min-width: 989px)')
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  if (!title || characters.length === 0) return

  let currentSlideIndex = 0
  let slideshowTimer

  const showSlide = (nextIndex) => {
    slides.forEach((slide, index) => {
      const active = index === nextIndex
      slide.classList.toggle('is-active', active)
      slide.setAttribute('aria-hidden', String(!active))
    })
    currentSlideIndex = nextIndex
  }

  const startSlideshow = () => {
    if (slides.length < 2 || reducedMotion.matches || slideshowTimer) return

    hero.classList.add('is-slideshow-playing')
    showSlide(0)
    slideshowTimer = window.setInterval(() => {
      showSlide((currentSlideIndex + 1) % slides.length)
    }, 6000)
  }

  const revealHero = () => {
    hero.classList.add('is-revealed')
    startSlideshow()
  }

  if (reducedMotion.matches) {
    showSlide(0)
    hero.classList.add('is-motion-ready', 'is-title-writing', 'is-title-sliding', 'is-revealed')
    return
  }

  const positionTitle = () => {
    if (!desktopLayout.matches) {
      title.style.setProperty('--recruiting-hero-title-offset-x', '0px')
      return
    }

    const rect = title.getBoundingClientRect()
    const offset = window.innerWidth / 2 - (rect.left + rect.width / 2)
    title.style.setProperty('--recruiting-hero-title-offset-x', `${offset}px`)
  }

  const startMotion = () => {
    positionTitle()
    hero.classList.add('is-motion-ready')

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        hero.classList.add('is-title-writing')
      })
    })

    const writeDuration = (characters.length - 1) * 88 + 520 + 160

    window.setTimeout(() => {
      if (!desktopLayout.matches) {
        hero.classList.add('is-title-sliding')
        revealHero()
        return
      }

      let completed = false
      const completeSlide = () => {
        if (completed) return
        completed = true
        revealHero()
      }

      title.addEventListener(
        'transitionend',
        (event) => {
          if (event.propertyName === 'transform') completeSlide()
        },
        { once: true }
      )

      hero.classList.add('is-title-sliding')
      window.setTimeout(completeSlide, 1320)
    }, writeDuration)
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(startMotion)
  } else {
    startMotion()
  }

  window.addEventListener(
    'pagehide',
    () => {
      if (slideshowTimer) window.clearInterval(slideshowTimer)
    },
    { once: true }
  )
})

document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('[data-rh-works-carousel]')
  const currentLink = document.querySelector('[data-rh-works-current-link]')
  const currentTitle = currentLink?.querySelector('[data-rh-works-current-title]')
  if (!carousel || !currentLink || !currentTitle) return

  const track = carousel.querySelector('.rh-works__track')
  const slides = Array.from(track?.children || [])
  const originalCount = Number(carousel.dataset.rhWorksCount)
  if (!track || slides.length === 0 || !originalCount) return

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  // 3周分のうち中央の周から開始し、左側が空かないようにする
  let currentIndex = originalCount
  let timer
  let resetting = false

  const centeredSlide = () => slides[currentIndex]

  const updateDetails = () => {
    const slide = centeredSlide()
    if (!slide) return

    slides.forEach((item, index) => {
      const active = index === currentIndex
      item.setAttribute('aria-hidden', String(!active))
      item.setAttribute('tabindex', active ? '0' : '-1')
    })
    currentTitle.textContent = slide.dataset.rhWorkTitle
    currentLink.href = slide.dataset.rhWorkUrl
  }

  const positionTrack = (animate = true) => {
    const slide = centeredSlide()
    if (!slide) return

    track.style.transition = animate && !reducedMotion.matches ? '' : 'none'
    const offset = carousel.clientWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2)
    track.style.transform = `translate3d(${offset}px, 0, 0)`
    updateDetails()
  }

  const showNext = () => {
    if (resetting) return
    currentIndex += 1
    positionTrack()
  }

  track.addEventListener('transitionend', (event) => {
    if (event.target !== track || event.propertyName !== 'transform' || resetting) return

    // 3周目に入ったら、見た目を保ったまま中央周へ戻す
    if (currentIndex >= originalCount * 2) {
      resetting = true
      currentIndex -= originalCount
      positionTrack(false)
      window.requestAnimationFrame(() => {
        resetting = false
      })
    }
  })

  positionTrack(false)

  if (originalCount > 1 && !reducedMotion.matches) {
    timer = window.setInterval(showNext, 3000)
  }

  window.addEventListener('resize', () => {
    currentIndex = originalCount + (currentIndex % originalCount)
    positionTrack(false)
  })
  window.addEventListener(
    'pagehide',
    () => {
      if (timer) window.clearInterval(timer)
    },
    { once: true }
  )
})

document.addEventListener('DOMContentLoaded', () => {
  const iframes = Array.from(document.querySelectorAll('.rh-formrun__iframe'))
  if (iframes.length === 0) return

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://form.run' && event.origin !== 'https://www.form.run') return

    let data = event.data
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data)
      } catch {
        return
      }
    }
    if (!data || !data.height) return

    iframes.forEach((iframe) => {
      if (event.source !== iframe.contentWindow) return
      iframe.style.height = `${data.height}px`
    })
  })
})
